<template>
	<v-flex>
		<v-currency-field
				@focus="focusAction"
				:readonly="$props.readonly"
				:mask="$props.mask"
				:label="$props.label"
				:placeholder="' '"
				:type="$props.type"
				v-bind="currency_config"
				:error-messages="$props.error"
				v-if="!isSimple"
				v-model="inputValue"></v-currency-field>
		<v-currency-field
				@focus="focusAction"
				:readonly="$props.readonly"
				:mask="$props.mask"
				:placeholder="$props.placeholder" :type="$props.type"
				class="simple"
				v-bind="currency_config"
				v-if="isSimple"
				v-model="inputValue"></v-currency-field>
	</v-flex>
</template>

<script>
	export default {
		name: "CurrencyField",
		props: ['simple', 'value', 'error', 'placeholder', 'label', 'type', 'mask', 'readonly', 'suffix'],
		data() {
			return {
				inputValue: this.$props.value,
				currency_config: {
					locale: 'de',
					prefix: '',
					suffix: this.$props.suffix,
					precision: 2,
					'auto-decimal-mode': false,
					allowBlank: false,
					min: Number.MIN_SAFE_INTEGER,
					max: Number.MAX_SAFE_INTEGER
				}
			}
		},
		computed: {
			isSimple() {
				return (typeof this.$props.simple !== 'undefined');
			},
			realSuffix() {
				if (this.$props.suffix !== 'undefined'){
					return this.$props.suffix;
				}
				else{
					return 'kn';
				}
			}
		},
		methods: {
			focusAction() {
				this.$emit('focus');
			}
		},
		watch: {
			inputValue() {
				this.$emit('input', this.inputValue);
			},
			value() {
				this.inputValue = this.$props.value;
			}
		}
	}
</script>

<style scoped>
	.simple {
		padding: 0px;
		margin: 0px;
	}

	>>> .simple .v-text-field__details {
		display: none;
	}

	>>> .simple .v-input__slot {
		padding: 0px;
		margin: 0px;
	}
</style>
